import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { DataService } from '../data.service';
import { Preinscripcio } from '../lib/model/preinscripcio';
import { DocumentPreinscripcio } from '../lib/model/documentPreinscripcio';
import { BLFitxer } from '../lib/bl/blfitxer';
import { BLPreinscripcio } from '../lib/bl/blpreinscripcio';
import { MatSnackBar, MatStepper } from '@angular/material';
import { NgForm } from '@angular/forms';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Component({
  selector: 'app-documentacio',
  templateUrl: './documentacio.component.html',
  styleUrls: ['./documentacio.component.css'],
  providers: [BLFitxer, BLPreinscripcio]
})
export class DocumentacioComponent implements OnInit {

  @ViewChild('formulari') formulari: NgForm;
  @Input() stepper: MatStepper;

  waiting = false;
  preinscripcio: Preinscripcio;
  stepPerformed = false;

  public selectedFiles;
  acceptExtensions = ['pdf', 'doc', 'jpg', 'docx', 'jpeg', 'png', 'odt', 'rtf'];

  constructor(
      public dataService: DataService,
      private blFitxer: BLFitxer,
      public blPreinscripcio: BLPreinscripcio,
      public snackBar: MatSnackBar,
      public i18n: I18n
  ) {
    this.preinscripcio = this.dataService.preinscripcio;
  }

  ngOnInit() {
  }

  isFileTypeValid(fileName: String): Boolean {
    for (let index = 0; index < this.acceptExtensions.length; index++) {
      const ext = this.acceptExtensions[index];
      if (fileName.toLowerCase().endsWith(ext)) {
        return true;
      }
    }
    return false;
  }

  public async filesSelect(document: DocumentPreinscripcio, selectedFiles: FileList) {
    try {
      document.waiting = true;
      console.log(document.tipusDocument.name);
      if (selectedFiles.length > 1) {
        this.snackBar.open(this.i18n('Només es pot seleccionar un fitxer!'), null, {
          duration: 5000,
        });
        return;
      }
      const file = selectedFiles[0];
      if (file.size > 12000000) {
        this.snackBar.open(this.i18n('La mida del fitxer no pot excedir de 12MB!'), null, {
          duration: 5000,
        });
        return;
      }
      if (!this.isFileTypeValid(file.name)) {
        this.snackBar.open(this.i18n('El tipus de fitxer no està suportat!'), null, {
          duration: 5000,
        });
        return;
      }
      const formData: FormData = new FormData();
      formData.append('file', file, file.name);
      const id = await this.blFitxer.upload(formData);
      document.nom = selectedFiles[0].name;
      document.fitxer = id;
      // this.selectedFiles = Array.from(selectedFiles.files).map(file => file.name);
    } catch (ex) {
        console.log(ex.Message);
        this.snackBar.open(ex.Message, null, {
            duration: 10000,
          });
    } finally {
      document.waiting = false;
    }
  }

  public eliminaDocumentPreinscripcio(document: DocumentPreinscripcio): void {
    document.nom = null;
    document.fitxer = 0;
  }

  public async continua() {
    try {
        this.waiting = true;
        this.preinscripcio = await this.blPreinscripcio.save(this.preinscripcio);
        this.dataService.preinscripcio = this.preinscripcio;
        this.snackBar.open(this.i18n('Preinscripció gravada correctament'), null, {
          duration: 2000,
        });
        setTimeout(() => {
              this.stepper.next();
        }, 2500);
        if (!this.stepPerformed) {
          this.dataService.maxStep++;
          this.stepPerformed = true;
        }
      } catch (ex) {
        console.log(ex.Message);
        this.snackBar.open(ex.Message, null, {
            duration: 10000,
          });
    } finally {
      this.waiting = false;
    }
  }

  public isValid(): boolean {
    try {
      if (this.formulari == null) {
        return false;
      }
      if (this.formulari.form == null) {
        return false;
      }
      if (this.formulari.form.invalid) {
        return false;
      }
      for (let index = 0; index < this.preinscripcio.documents.length; index++) {
        const doc = this.preinscripcio.documents[index];
        if (doc.obligatori && doc.fitxer === 0) {
          return false;
        }
      }
    } catch (ex) {
      console.log('Error a isValid()');
      console.log(ex.Message);
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/documentacio/documentacio.component.ts